import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Img1 from "../assets/icon-folder/1.png";
import Img2 from "../assets/icon-folder/2.png";
import Img3 from "../assets/icon-folder/3.png";
import Img4 from "../assets/icon-folder/4.png";
import Img5 from "../assets/icon-folder/5.png";
import Img6 from "../assets/icon-folder/6.png";
import Img7 from "../assets/icon-folder/7.png";
import Img8 from "../assets/icon-folder/8.png";

gsap.registerPlugin(ScrollTrigger);

function Logoslide() {
  const ctxRef = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Top row moves to the right
      gsap.to(".logo-row-top", {
        xPercent: 30,
        ease: "none",
        scrollTrigger: {
          trigger: ".logo-section",
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });

      // Bottom row moves to the left
      gsap.to(".logo-row-bottom", {
        xPercent: -30,
        ease: "none",
        scrollTrigger: {
          trigger: ".logo-section",
          start: "top bottom",
          end: "bottom top",
          scrub: 1,
        },
      });
    });

    ctxRef.current = ctx;
    return () => ctx.revert();
  }, []);

  return (
    <div className="logo-section h-[30vh] flex flex-col justify-center items-center overflow-hidden relative">
      {/* Top row */}
      <ul className="logo-row-top flex whitespace-nowrap mb-1 -ml-80   ">
        {[Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8 ].map((img, i) => (
          <li key={i} >
            <img
              src={img}
              alt={`logo-${i}`}
     className="h-[100%] w-[260px] h-auto object-contain drop-shadow-lg hover:scale-110 transition-transform duration-300"
            />
          </li>
        ))}
      </ul>

      {/* Bottom row */}
      <ul className="logo-row-bottom gap-[25px]  items-center flex whitespace-nowrap -mr-80">
        {[Img4, Img7, Img5, Img6, Img1, Img2, Img3, Img8].map((img, i) => (
          <li key={i}>
            <img
              src={img}
              alt={`logo-${i}`}
              className="h-[100%] w-[260px] h-auto object-contain drop-shadow-lg hover:scale-110 transition-transform duration-300"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Logoslide;
